import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class IncomeReceiptPdfDetail extends BaseModel {
    @Expose() name = "";
    @Expose() stream = "";
    @Expose() responseCode = "";
}
